<article class="mp-card">
    <div class="mp-card__badges">
        <span class="mp-type-badge mp-type-badge--{{item.kindStyle}}">{{item.kindLabel}}</span>
        @if (item.presentationKind === 'roadmapIdea') {
            <span class="mp-status-badge mp-status-badge--{{item.statusStyle}}">{{item.statusLabel}}</span>
        }
    </div>
    <h3>{{item.title}}</h3>
    <p class="mp-card__teaser">{{item.teaser}}</p>
    <div class="mp-card__tags" role="list" aria-label="Tags">
        @for (tag of item.tags.slice(0, 3); track tag.key) {
            <span role="listitem">{{tag.label}}</span>
        }
    </div>
    <p class="mp-card__provider">by {{item.provider}}</p>
    <footer>
        <span class="mp-card__commercial">
            @if (item.presentationKind === 'roadmapIdea') {
                Shape what comes next
            } @else if (pricingVisible) {
                {{item.commercialSummary || 'Quote on request'}}
            } @else {
                Pricing according to your agreement
            }
        </span>
        <span class="mp-card__actions">
            <button pButton type="button" class="mp-link-button" (click)="openDetails()">Details</button>
            <button pButton type="button" class="mp-outline-button" [disabled]="primaryActionDisabled" (click)="runAction()">{{actionLabel}}</button>
        </span>
    </footer>
</article>
